import { Component, OnInit, Output, EventEmitter, AfterViewInit, Input } from '@angular/core';
import { Validators } from "@angular/forms";
import { ApplicationSteps, ApplicationState } from "../../../../models/applications.models";
import { Option } from "../../../../../common/models/flow.dto";
import { SystemSetting } from "../../../../../admin/models/system-setting.model";
import { ExpeditingConfig } from "../../../../../services/application-config.service";
import { ApplicationSectionBaseComponent } from "../../../application-section-base/application-section-base.component";
import { AuthService } from "../../../../../services/auth.service";


@Component({
    selector: 'app-permit-type',
    templateUrl: './permit-type.component.html',
    styleUrls: ['./permit-type.component.scss', '../../../../../core/components/collapsible/collapsible.component.scss', '../../../application-section-base/application-section-base.component.scss'],
    standalone: false
})
export class PermitTypeComponent extends ApplicationSectionBaseComponent implements OnInit, AfterViewInit {

	readonly step: ApplicationSteps = ApplicationSteps.PermitType;

	_expediteSetting: SystemSetting = null;

	get expeditSetting(): SystemSetting {
		return this._expediteSetting;
	}

	@Input() expediteConfig: ExpeditingConfig = null;

	private _expediteMessage: string;

	get expediteMessage(): string {
		if (this._expediteMessage == null) {
			this._expediteMessage = this.expediteConfig != null
				? this.expediteConfig.expediteMessage
				: "";
		}
		return this._expediteMessage;
	}

	private _noExpediteMessage: string;

	get noExpediteMessage(): string {
		if (this._noExpediteMessage == null) {
			this._noExpediteMessage = this.expediteConfig != null
					? this.expediteConfig.noExpediteMessage
					: "";
			}
		return this._noExpediteMessage;
	}

	@Input() set expediteSetting(value: SystemSetting) {
		this._expediteSetting = value;
		let ctrl = this.form.get('expedite');
		if (ctrl != null) {
			if (this._expediteSetting.isActive && this.reviewStates.includes(this.applicationState) == false) {
				ctrl.enable() ;
			} else {
				ctrl.disable();
			}
		}
	}

    get apiInvalid(): boolean {
        if (this.form == null) return false;
        let ctrl = this.form.get("existingAPI");
        if (ctrl == null) return false;
        return ctrl.invalid;
    }


    @Output() changeOrientation: EventEmitter<string> = new EventEmitter<string>();




    orientationOptions: Option[] = [
        { id: "Vertical", text: "Vertical" } as Option,
        { id: "Directional", text: "Directional" } as Option,
        { id: "Horizontal", text: "Horizontal" } as Option,
        { id: "Other Horizontal", text: "Other Horizontal" } as Option
    ];

    permitOptions: Option[] = [
        { id: "Drill", text: "Drill a New Well" } as Option,
        { id: "Permit to Convert", text: "Convert" } as Option,
        { id: "Permit to Deepen", text: "Deepen" } as Option,
        { id: "Permit to Plug Back", text: "Plug Back" } as Option,
        { id: "Permit to Reopen", text: "Reopen" } as Option,
        { id: "Permit to Revise Location", text: "Revise Location" } as Option,
        { id: "Reissue a Previously Issued Permit", text: "Reissue" } as Option
    ];

    @Output() permitTypeUpdated: EventEmitter<string> = new EventEmitter<string>();

    get showFeeSimple(): boolean {
        if (this.form == null) return false;
        const ctrl = this.form.get('expedite');
        if (ctrl == null) return false;
        return ctrl.value == "true" || ctrl.value == true;
    }

    constructor(_auth: AuthService) { super(_auth); }

	ngOnInit() {
		
    }

    ngAfterViewInit() {
        if (this.applicationState == ApplicationState.Corrections) {
            if (this.fieldHasNotes('permitType|type')) {
                this.permitTypeChanged(this.form.get('type'));
            }
          
        }
	}

    orientationChanged(event: any): void {
        this.changeOrientation.emit(event);
    }

    permitTypeChanged(event: any): void {
        if (event == 'Drill') {
            this.form.get("existingAPI").clearValidators();
            this.form.get("existingAPI").setValue(null);
            this.form.get("existingAPI").disable();
        } else {
            this.form.get("existingAPI").setValidators([Validators.required, Validators.minLength(14), Validators.maxLength(14), Validators.pattern(new RegExp("^[0-9]"))]);
            this.form.get("existingAPI").enable();
        }
        this.form.get("existingAPI").updateValueAndValidity();
        this.permitTypeUpdated.emit(event);
    }

    toggleOpen(): void {
        if (this.step == this.activeStep || !this.isOpen) super.toggleOpen();
        this.openChanged.emit(this.step);
    }
}
